import React from "react";
import PhoneInput from "react-phone-input-2";
import {Controller} from "react-hook-form";

export const PhoneInput2 = ({
                                label = "",
                                placeholder,
                                control,
                                rules,
                                name,
                                className,
                                disabled,
                                mask,
                                allowError = true
                            }) => {
    return (
        <div className={`input-main-wrapper  ${className ? className : ""}`}>
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({field, fieldState: {error}}) => {
                    const {ref, onChange, value, ...restField} = field;
                    return (
                        <>
                            <PhoneInput
                                {...restField}
                                value={value || ""}
                                containerClass={`phone-input-main ${error?.message ? "phone-input-main-error" : ""}`}
                                inputProps={{
                                    ref: ref,
                                    name,
                                }}
                                placeholder={placeholder}
                                onChange={(value) => field.onChange(value)}
                                inputStyle={{width: "100%"}}
                                country={"us"}
                                specialLabel={label}
                                disabled={disabled}
                                disableCountryCode
                                alwaysDefaultMask
                                defaultMask={mask ? mask : "(...) ...-...."}
                            />
                            {allowError &&
                                <p className="error-message">
                                    {error?.type === "required"
                                        ? "This Field is required"
                                        : error?.message}
                                </p>
                            }
                        </>
                    );
                }}
            />
        </div>
    );
};
